<template>
  <!-- 电波通 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item form="name">
              <el-input v-model="form.name" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;新增团队介绍
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column  prop="name" label="团队名称" show-overflow-tooltip>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column  fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增团队介绍': operation == 'edit' ? '编辑团队介绍':'查看团队介绍'" @close="onCancel" :close-on-click-modal="false"   :visible.sync="dialogVisible" :width="'60%'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="14">
              <el-form-item class="mb-30" prop="name">
                <el-input v-model="addForm.name" :disabled="operation == 'view'" placeholder="请输入团队名称" />
              </el-form-item>

              <el-form-item class="mb-30" prop="des">
                <cmp-ckeditor ref="myCkeditor" :readOnly="operation === 'view'" :defaultMsg="addForm.des" :id="`ue1`" :height="150"></cmp-ckeditor>
                <!-- <el-input type="textarea" v-model="addForm.des" :disabled="operation == 'view'" placeholder="请输入团队简介" /> -->
              </el-form-item>

              <el-form-item class="mb-30" prop="videoUrl">
                <el-input v-model="videoUrl" disabled placeholder="上传团队视频自动获取URL" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item class="avatar-uploader-form" prop="spid">
                <div class="avatar-uploader" @click="uploadPicture(1)">
                  <img v-if="addForm.spid" :src="addForm.spid" class="avatar" />
                  <div class="img-uploader c-p w-100" v-else>
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__text">上传团队封面</div>
                  </div>
                  <div class="tip-img">建议图片大小：345 * 184</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="14">
              <el-form-item class="avatar-uploader-form" prop="voideurl">
                <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="video/*" :data="configData" :show-file-list="false" :on-progress="uploadVideoProcess" :on-success="handleVideoSuccess" :before-upload="beforeVideoUpload">
                  <video v-if="videoUrl != '' && !videoFlag" v-bind:src="videoUrl" class="w-100" controls="controls">
                    您的浏览器不支持视频播放
                  </video>

                  <div class="tip img-uploader" v-else-if="videoUrl == '' && !videoFlag">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__text">上传团队视频</div>
                  </div>

                  <div class="tip-img">建议视频大小：375 * 325</div>
                  <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent" style="margin-top: 7px"></el-progress>
                </el-upload>

              </el-form-item>

            </el-col>
            <el-col :span="10">
              <el-form-item class="avatar-uploader-form" prop="spMain">
                <div class="avatar-uploader" @click="uploadPicture(2)">
                  <img v-if="addForm.spMain" :src="addForm.spMain" class="avatar" />
                  <div class="img-uploader c-p w-100" v-else>
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__text">上传视频封面</div>
                  </div>
                  <div class="tip-img">建议图片大小：345 * 184</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item required>
              <el-upload :file-list="fileList" action="/singleMuseum/attach/upload" list-type="picture-card" :disabled="operation == 'view'" accept="image/*" :data="configData" :on-remove="handleUnitPicRemove" :on-success="handleUnitPicSuccess" :before-upload="beforeUnitPicUpload">
                <div class="img-uploader">
                  <i class="el-icon-plus"></i>
                  <span>上传团队图片</span>
                </div>
              </el-upload>

            </el-form-item>
          </el-row>

        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation != 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CropperImage from "@cmp/cropper";
import cmpCkeditor from '@cmp/editor/ckeditor'
export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  components: { CropperImage, cmpCkeditor },
  data() {
    const validateSpMain = (rule, value, callback) => {
      if (!this.addForm.spMain) {
        callback(new Error('项目封面不能为空'))
      } else {
        callback()
      }
    }

    const validateSpId = (rule, value, callback) => {
      if (!this.addForm.spid) {
        callback(new Error('视频封面不能为空'))
      } else {
        callback()
      }
    }

    const validateVideourl = (rule, value, callback) => {
      if (!this.addForm.voideurl) {
        callback(new Error('视频地址不能为空'))
      } else {
        callback()
      }
    }

    return {
      form: {
        type: '1',
        name: '',
      },
      fileList: [],
      operation: 'add',
      addForm: {
        name: '',
        des: '',
        voideurl: '',
        spid: '',
        spMain: ''
      },
      rules: {
        name: [{ required: true, message: '团队名称不能为空', trigger: 'blur' }],
        spid: [{ required: true, validator: validateSpId, trigger: 'change' }],
        spMain: [{ required: true, validator: validateSpMain, trigger: 'change' }],
        // voideurl: [{ required: true, validator: validateVideourl, trigger: 'change' }],
      },
      configData: {
        tableName: 'collect'
      },
      videoUrl: "",
      videoFlag: false,
      videoUploadPercent: 0,
      imgUrl: "",
      pics: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getVolunteerGroupList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    handleUploadSuccess(res) {
      if (this.type == 1) {
        this.addForm.spid = res.attPath
      } else if (this.type == 2) {
        this.addForm.spMain = res.attPath
      }

    },

    //封面设置
    uploadPicture(type) {
      if (this.operation == 'view') {
        return
      }
      this.type = type
      if (this.type == 1) {
        this.imgUrl = this.addForm.spid
      } else if (this.type == 2) {
        this.imgUrl = this.addForm.spMain
      }
      let option = {
        cropWidth: "375", cropHeight: "215", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    // 重置查询
    resetForm() {
      this.form = {
        type: '1',
        name: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },
    

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getVolunteerGroupDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result

            if(this.addForm.voideurl){
              this.videoUrl = this.addForm.voideurl
            }

            console.log(this.addForm.voideurl)

            if (res.result.pics) {
              let fileList = res.result.pics.split(';')
              fileList.map(item => {
                if (item) {
                  if (item.indexOf('http') != -1 || item.indexOf('/singleMuseum/attach/getFile') != -1) {
                    this.fileList.push({
                      url: item
                    })
                  } else {
                    this.fileList.push({
                      url: `/singleMuseum/attach/getFile?fileId=${item}`
                    })
                  }
                }
              })
            }

          }
        }
      })
    },

    // 新增
    handleAdd(operator, id) {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      // if (obj.spMain && obj.spMain.indexOf('/singleMuseum/attach/getImg') == -1) {
      //   this.imgUrl = `/singleMuseum/attach/getImg?fileId=${obj.spMain}`
      // } else {
      //   this.imgUrl = obj.spMain
      // }

      // if (obj.spid && obj.spid.indexOf('/singleMuseum/attach/getFile') == -1) {
      //   this.videoUrl = `/singleMuseum/attach/getFile?fileId=${obj.spid}`
      // } else {
      //   this.videoUrl = obj.spid
      // }

      this.videoUrl = obj.voideurl

      if (this.addForm.pics) {
        this.pics = this.addForm.pics.split(',')
        this.pics.map(item => {
          this.fileList.push({
            url: `/singleMuseum/attach/getFile?fileId=${item}`
          })
        })
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delVolunteerGroup({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeVideoUpload(file) {
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(file.type) == -1     //控制格式
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
    },

    handleVideoSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.videoFlag = false;
        this.videoUploadPercent = 0;
        this.videoUrl = res.result.attPath
        this.addForm.voideurl = res.result.attPath
      } else {
        this.$message.error(res.message)
      }
    },

    //进度条
    uploadVideoProcess(event, file, fileList) {   
      this.videoFlag = true // 显示进度条
      this.videoUploadPercent = parseInt(file.percent)
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return false
      }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return false
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.spMain = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    // 上传团队图片
    beforeUnitPicUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return
      }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleUnitPicSuccess(res, file, fileList) {
      if (res.success) {
        this.$message.success('上传成功')
        this.pics.push(res.result.attId)
      } else {
        let index = 0;
        for (const i in fileList) {
          if (fileList[i] == file) {
            index = i;
            break;
          }
        }
        //移出当前文件对象
        fileList.splice(index, 1);
        this.$message.error(res.message)
      }
    },

    handleUnitPicRemove(file, fileList) {
      this.pics = []
      if (fileList && fileList.length > 0) {
        fileList.map(item => {
          if (item.response && item.response.result) {
            this.pics.push(item.response.result.attId)
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('=')
              this.pics.push(arr[1])
            }
          }
        })
        console.log(this.pics)
      }
    },

    onSubmit() {
      const self = this

      let des = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (!des) {
        this.$message.info('团队简介不能为空')
        return
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "addVolunteerGroup"
          if (this.addForm.id) {
            url = "updateVolunteerGroup"
          } else {
            this.addForm.type = '1'
          }

          if (this.pics && this.pics.length > 0) {
            this.addForm.pics = this.pics.join(',')
          } else {
            this.addForm.pics = ""
          }
          this.$api.applet[url]({
            ...this.addForm,
            des: des
          }).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '团队介绍修改成功' : '团队介绍新增成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.videoUrl = ""
      this.videoFlag = false
      this.videoUploadPercent = 0
      this.fileList = []
      this.pics = []
      this.$refs["form"].clearValidate()
      this.$refs.myCkeditor.initEditor()

    },

    guide(obj) {
      this.$router.push({
        path: '/applet-management/guide-management',
        query: { guideId: obj.id }
      })
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },


    // handleProjectSub(row) {
    //   this.$router.push({
    //     path: '/project/sub',
    //     query: { type: 'task', projectId: row.projectId, projectName: row.projectName }
    //   })
    // },
  },
  created() {
    this.getData()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
      .el-date-editor,
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      .avatar-uploader {
        width: 100%;
        display: flex;
        height: 215px;
        display: flex;
        cursor: pointer;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px dashed #8c939d;
        .el-upload {
          height: 100%;
          video {
            width: 100%;
            height: 100%;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        i {
          font-size: 34px;
        }
      }
    }
    .img-uploader {
      cursor: pointer;
      height: 100%;
      line-height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }
}
</style>